import { NotificationEventEnum } from '.'
import { IFIStatus } from '../statuses/ifi'
import { NotificationEventItem } from './NotificationEventItem'
import { CommentedNotificationEventItem } from './common/commented'
import { EditedNotificationEventItem } from './common/edited'
import { RevertedNotificationEventItem } from './common/reverted'

const ifi = 'Identified Field Issue'

const IssueSuggested = new NotificationEventItem({
  id: '0a7df347-f828-458d-affd-106dd5a38ffb',
  name: 'Issue Suggested',
  description: `An ${ifi} is imported from the CIMS Field App`,
})

const IssueSummarized = new NotificationEventItem({
  id: '73cc47b3-987c-4a91-8052-4224c547d09a',
  name: 'Issue Summarized',
  description: `A summary list of recently created ${ifi}s, sent out on a time interval`,
})

const Closed = new NotificationEventItem({
  id: 'dff7276c-7ffe-4512-9a0b-b92e10815af2',
  name: 'Closed',
  description: `A User reviews and closes an ${ifi}`,
})
const Edited = EditedNotificationEventItem({
  id: '7f83d348-54cc-4ce1-9145-ce163221cd1c',
  editable: 'Identified Field Issue',
})
const Reverted = RevertedNotificationEventItem({
  id: '29ba1e78-e2ee-46f7-a4b9-ec7f42aa778f',
  revertable: 'Identified Field Issue',
  from: IFIStatus.Closed,
  to: IFIStatus.PendingReview,
})
const Commented = CommentedNotificationEventItem({
  id: '6e0d4794-613c-42ce-af8e-2d7fe291e20c',
  commentable: 'Identified Field Issue',
})

export type IFINotificationEventItem =
  | typeof IssueSuggested
  | typeof Closed
  | typeof Edited
  | typeof Reverted
  | typeof Commented
  | typeof IssueSummarized

class IFINotificationEventEnum extends NotificationEventEnum<
  'IFINotification',
  IFINotificationEventItem,
  IFINotificationEventItem['name'],
  IFINotificationEventItem['id']
> {
  typename = 'IFINotification' as const
  get values() {
    return [
      this.IssueSuggested,
      this.Closed,
      this.Edited,
      this.Reverted,
      this.Commented,
      this.IssueSummarized,
    ]
  }
  readonly IssueSuggested = IssueSuggested
  readonly Closed = Closed
  readonly Edited = Edited
  readonly Reverted = Reverted
  readonly Commented = Commented
  readonly IssueSummarized = IssueSummarized
}

export const IFINotificationEvent = new IFINotificationEventEnum()
